import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { ISalesByDay } from "src/types/reports";

const colors = ["#0075FF", "#16AA75", "#A155B9", "#CC9C33"];

const TotalSalesLinearChart = ({ data }: { data: ISalesByDay[] }) => {
  const theme = useTheme();
  const matchesMediumUp = useMediaQuery(theme.breakpoints.up("md"));

  const totalArr: any = [];
  const xAxisLabels: any = [];
  const onlineArr: any = [];
  const cardArr: any = [];
  const cashArr: any = [];

  data?.forEach((item) => {
    xAxisLabels.push(item.date);
    totalArr.push(item.totalSales.toFixed(1));
    onlineArr.push(item.onlineSales.toFixed(1));
    cardArr.push(item.cardSales.toFixed(1));
    cashArr.push(item.cashSales.toFixed(1));
  });

  const series = [
    {
      name: "Total Sales",
      data: totalArr,
    },
    {
      name: "Card Payment",
      data: cardArr,
    },
    {
      name: "Cash Payment",
      data: cashArr,
    },
    {
      name: "Online Payment",
      data: onlineArr,
    },
  ];

  const options: ApexCharts.ApexOptions = {
    theme: {
      mode: "dark",
    },
    colors: colors,
    noData: {
      text: "No data available ",
      style: {
        fontSize: "15px",
      },
    },
    chart: {
      redrawOnParentResize: true,
      toolbar: {
        show: false, // Hide the download icons
      },
      type: "line",
      zoom: {
        enabled: false,
      },
      foreColor: "#f0f0f0",
      background: "#242424",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
      width: 2.5,
    },
    markers: {
      size: 3, // Adjust the size of the marker
      shape: "circle",
      strokeColors: colors,
    },
    xaxis: {
      labels: {
        show: false,
      },
      categories: xAxisLabels,
    },
    grid: {
      borderColor: "#000",
      show: true,
    },
    legend: {
      show: true,
      fontSize: "13.3px",
      itemMargin: {
        horizontal: matchesMediumUp ? 15 : 5,
        vertical: 5,
      },
      markers: {
        width: 8,
        height: 8,
        strokeWidth: 0,
        radius: 0,
      },
    },
  };

  return (
    <Box
      bgcolor={"#242424"}
      overflow={"hidden"}
      pb={"10px"}
      borderRadius={"12px"}
    >
      <Box bgcolor={"#242424"} padding={"21px 24px"}>
        <Typography fontWeight={700} fontSize={"20px"}>
          Total Sales
        </Typography>
      </Box>
      <Box bgcolor={"#000000"} height={"2px"} />
      <ReactApexChart
        series={series}
        options={options}
        height={300}
        type="line"
        width={"100%"}
      />
    </Box>
  );
};

export default TotalSalesLinearChart;
